import React from "react";
import { Link, graphql } from "gatsby";
import Image from "gatsby-image";
import Bio from "../components/bio";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { PostContent } from "../components/page";
import ContactFooter from "../components/ContactFooter";

import "./post.scss";

const PostTemplate = ({ data: { previous, next, post } }) => {
  const featuredImage = {
    fluid: post.featuredImage?.node?.localFile?.childImageSharp?.fluid,
    alt: post.featuredImage?.node?.alt || ``,
  };

  let src = featuredImage?.fluid?.src || "";
  let acf = post.acfPageInterne;

  return (
    <Layout post={post}>
      <SEO title={post.title} description={post.excerpt} post={post} />
      <PostContent post={post} acf={acf} src={src} />
      <ContactFooter />
    </Layout>
  );
};

export default PostTemplate;

export const pageQuery = graphql`
  query PostById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
    $previousPostId: String
    $nextPostId: String
  ) {
    # selecting the current post by id
    post: wpPost(id: { eq: $id }) {
      id
      uri
      excerpt
      content
      title
      date(formatString: "MMMM DD, YYYY")
      categories {
        nodes {
          name
        }
      }
      slug
      seo {
        canonical
        title
        metaDesc
        focuskw
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphAuthor
        opengraphDescription
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
          localFile {
            childImageSharp {
              fluid(maxWidth: 700, quality: 90, toFormat: JPG) {
                src
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
        opengraphUrl
        opengraphSiteName
        opengraphPublishedTime
        opengraphModifiedTime
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
          localFile {
            childImageSharp {
              fluid(maxWidth: 700, quality: 90, toFormat: JPG) {
                src
                ...GatsbyImageSharpFluid_withWebp_noBase64
              }
            }
          }
        }
        breadcrumbs {
          url
          text
        }
        cornerstone
        schema {
          pageType
          articleType
          raw
        }
        readingTime
      }
      acfPageInterne {
        contenthead
        contenudynamique {
          ... on WpPost_Acfpageinterne_Contenudynamique_Texte {
            fieldGroupName
            texte
          }
          ... on WpPost_Acfpageinterne_Contenudynamique_Conseil {
            fieldGroupName
            texte
            titre
            image {
              altText
              localFile {
                childImageSharp {
                  fluid(maxHeight: 147, quality: 90) {
                    src
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
            wallpaperSize
            wallpaper {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 700, quality: 80) {
                    src
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
          }
          ... on WpPost_Acfpageinterne_Contenudynamique_Lien {
            fieldGroupName
            texte
            image {
              altText
              localFile {
                childImageSharp {
                  fluid(maxHeight: 147, quality: 90, toFormat: JPG) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                    src
                  }
                }
              }
            }
            lien {
              target
              title
              url
            }
          }
          ... on WpPost_Acfpageinterne_Contenudynamique_Form {
            fieldGroupName
          }
          ... on WpPost_Acfpageinterne_Contenudynamique_Texteimage {
            fieldGroupName
            texte
            placementDeLimage
            imageFormat
            image {
              altText
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1000, quality: 100, toFormat: JPG) {
                    src
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
          }
          ... on WpPost_Acfpageinterne_Contenudynamique_Carte {
            fieldGroupName
            texte
            placementDeLaCarte
          }
          ... on WpPost_Acfpageinterne_Contenudynamique_Image {
            fieldGroupName
            placementDeLimage
            image {
              altText
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1000, quality: 100, toFormat: JPG) {
                    src
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
            description
          }
        }
      }

      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              fluid(maxWidth: 1000, quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
        }
      }
    }

    # this gets us the previous post by id (if it exists)
    previous: wpPost(id: { eq: $previousPostId }) {
      uri
      title
    }

    # this gets us the next post by id (if it exists)
    next: wpPost(id: { eq: $nextPostId }) {
      uri
      title
    }
  }
`;
